export const hideSnippetFunction = () => {
    const cbHtml = document.querySelector("#_cbhtml");
    if (cbHtml) {
        const snippetHable = document.querySelector(".snippetlist");
        snippetHable.classList.remove("active")
    }
}